import api from "../services/api";
import {useRecoilState, useRecoilValue, useResetRecoilState} from "recoil";
import {spaceIdState} from "../state/spaceState";
import {useQuery} from "react-query";
import useUser from "./useUser";
import firebaseApp from "../services/firebase";
import {useEffect} from "react";
import firebaseState from "../state/firebaseState";
import queryClient from "../services/queryClient";

const loginFirebase = (timing) => api.post(`/timings/${timing}/firebase`).then(res => res.data);

const useLoginFirebase = () => {
  const user = useUser();
  const id = useRecoilValue(spaceIdState);

  const [firebase, setFirebase] = useRecoilState(firebaseState);
  const resetFirebase = useResetRecoilState(firebaseState);

  useEffect(() => {
    const firebaseAuthStateListener = firebaseApp.auth().onAuthStateChanged((user) => {
      setFirebase(old => ({
        ...old,
        uid: user?.uid || null,
      }));

      user?.getIdTokenResult().then(data => {
        setFirebase(old => ({
          ...old,
          claims: data.claims,
        }));
      })
    });

    return () => {
      queryClient.resetQueries([id, 'firebase']);
      firebaseApp.auth().signOut();
      firebaseAuthStateListener && firebaseAuthStateListener();
      resetFirebase();
    };
  }, []);

  return useQuery([id, 'firebase'], () => loginFirebase(id), {
    enabled: !!user?.id,
    staleTime: Infinity,
    onSuccess: async ({data, access_token}) => {
      await firebaseApp.auth().signInWithCustomToken(access_token);

      return data;
    }
  })
};

export default useLoginFirebase;
